import { useContext, useEffect, useState } from 'react'
import 'react-quill/dist/quill.snow.css'
import { PRODUCT_MAP } from '../../../../constants/products'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import OpenHouse from '../../Configuration/Product/OpenHouse'
import './styles.css'

const OpenHouseSettings = () => {
  const { productsService } = useContext(SiteConfigContext)
  const [current, setCurrent] = useState()

  useEffect(() => {
    if (productsService) {
      setCurrent(productsService[PRODUCT_MAP.THIS_PRODUCT])
    }
  }, [productsService])

  const updateState = (data) => {
    setCurrent(data)
  }

  if (!current) {
    return null
  }

  if (!current?.openHouse?.enabled) {
    return (
      <div className="flex flex-col gap-2">
        <h2>Open House is not enabled</h2>
      </div>
    )
  }

  return <OpenHouse product={current} updateState={updateState} hideToggle />
}

export default OpenHouseSettings
